import type { Integrations } from '@lokalise/translation-api-schemas'
import type { HTMLAttributes } from 'react'
import { ClaudeAiIcon, DynamicRoutingAiIcon, GeminiAiIcon, GptAiIcon } from './icons'

type AiModelIconProps = {
  integration: Integrations
  size?: string
}

export const AiModelIcon = ({
  integration,
  size,
  ...props
}: AiModelIconProps & HTMLAttributes<SVGElement>) => {
  switch (integration) {
    case 'claude':
      return <ClaudeAiIcon size={size} {...props} />

    case 'gpt':
      return <GptAiIcon size={size} {...props} />

    case 'gemini':
      return <GeminiAiIcon size={size} {...props} />

    default:
      return <DynamicRoutingAiIcon size={size} {...props} />
  }
}
